export default function CentreGestionConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('centre.gestion');
}

CentreGestionConfiguration.$inject = ['$translatePartialLoaderProvider'];
